// @ts-nocheck
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    blogSummary: string;
    extendedStyles?: BlogSummaryStyles;
}

export interface BlogSummaryStyles {
    textSummary?: TypographyPresentationProps;
}

export const blogSummaryStyles: BlogSummaryStyles = {
    textSummary: {
        css: css`
            margin-bottom: ${pxToRem(15)};
        `,
    },
};

const BlogSummary = ({ blogSummary, extendedStyles }: Props) => {
    const styles = useMergeProps(blogSummaryStyles, extendedStyles);

    return <Typography {...styles.textSummary}>{blogSummary}</Typography>;
};

export default BlogSummary;
